module.exports = __webpack_public_path__ + "img/IQ.16693663.svg";